import DeviceStorage from '@/libs/device-storage';

/**
 * If user is not authenticated, redirect to login.
 * @returns {Promise}
 */
export default function ({ store, redirect, route, from }) {
  const hasSsoLogin = store.state.distributor.data?.data?.useGovLogin;
  const isApiLogoutDone = !!from.query?.logout;

  if (hasSsoLogin && isApiLogoutDone) {
    const logoutUrl = new URL(
      `${store.state.config.govLoginEnvironment}/logout`
    );

    const postLogoutRedirectUri =
      store.state.distributor.data?.data?.govRedirectUri.replace(
        'login',
        'logout?sessionEnded=true'
      );

    logoutUrl.searchParams.append(
      'post_logout_redirect_uri',
      postLogoutRedirectUri
    );

    window.open(logoutUrl, '_self', 'noopener noreferrer');
  }

  return store.dispatch('user/check').catch(() => {
    const session = DeviceStorage.get('session');
    if (session) {
      store.commit('user/clearSession');
    }
    return redirect({ path: '/login', query: { goto: route.path } });
  });
}
